import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
	OrganizationInsurer,
	OrganizationInsurerPostPayload,
} from '@/organization/organization/organization-insurer/organization-insurer.model';
import { environment } from '../../../../environments/environment';
import { Organization, Result } from '@/reservation/reservation.model';
import { map, Observable } from 'rxjs';
import { Insurer } from '@/codebook/insurer/_types/insurer.type';

@Injectable({
	providedIn: 'root',
})
export class OrganizationInsurerApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getInsurerList(): Observable<Insurer[]> {
		return this.httpClient
			.get<Result<Insurer>>(`${this.apiUrl}/insurance/insurer/`)
			.pipe(map((response) => response.results));
	}

	getOrganizationInsurerList(organizationId: number): Observable<OrganizationInsurer[]> {
		return this.httpClient
			.get<Result<OrganizationInsurer>>(`${this.apiUrl}/organization/${organizationId}/insurer/`)
			.pipe(map((response) => response.results));
	}

	createOrganizationInsurer(
		organizationId: number,
		payload: OrganizationInsurerPostPayload,
	): Observable<OrganizationInsurerPostPayload> {
		return this.httpClient.post<OrganizationInsurerPostPayload>(
			`${this.apiUrl}/organization/${organizationId}/insurer/`,
			payload,
		);
	}

	updateOrganizationInsurer(
		organizationId: number,
		payload: OrganizationInsurerPostPayload,
	): Observable<OrganizationInsurerPostPayload> {
		return this.httpClient.put<OrganizationInsurerPostPayload>(
			`${this.apiUrl}/organization/${organizationId}/insurer/${payload.insurer}/`,
			payload,
		);
	}

	patchOrganization(organizationId: number, payload: Partial<Organization>): Observable<Organization> {
		return this.httpClient.patch<Organization>(`${this.apiUrl}/organization/${organizationId}/`, payload);
	}
}
